module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/babel-runtime/core-js/symbol/iterator.js
 ** module id = 205
 ** module chunks = 1
 **/